export default __webpack_public_path__ + "static/media/paymentTutorial_pc_middle_En.da61cba1.webp";